export default __webpack_public_path__ + "static/media/callIcon.6e4b4519.svg";